@import 'core';

$properties: (
  breadcrumb-delimiter: "'/'",
  breadcrumb-delimiter-margin-left: 8px,
  breadcrumb-delimiter-margin-right: 8px,
);

:host {
  @each $key, $value in $properties {
    --#{$key}: #{$value};
  }
}

:host([theme='default']) {
  @include ads-vars-component-breadcrumbs-default;
}

:host([theme='dark']) {
  @include ads-vars-component-breadcrumbs-dark;
}

:host([theme='light']) {
  @include ads-vars-component-breadcrumbs-light;
}

// Safari hack
:host(:not(:last-child)) {
  &::after {
    content: var(--breadcrumb-delimiter);
    margin-left: var(--breadcrumb-delimiter-margin-left);
    margin-right: var(--breadcrumb-delimiter-margin-right);
  }
}

.c-breadcrumb {
  font-family: var(--ads-font-family);
  font-size: inherit;
  font-weight: inherit;

  &__anchor {
    @include ads-anchor;
    color: var(--ads-breadcrumbs-link-color, $ads-breadcrumbs-link-color);
    font-family: inherit;
    text-decoration: var(--ads-breadcrumbs-text-decoration, $ads-breadcrumbs-text-decoration);

    &:visited {
      color: var(--ads-breadcrumbs-link-color-visited, $ads-breadcrumbs-link-color-visited);
    }

    &:focus,
    &:hover {
      --ads-anchor-text-decoration-hover: var(--ads-breadcrumbs-text-decoration-hover, $ads-breadcrumbs-text-decoration-hover);
      color: var(--ads-breadcrumbs-link-color-hover, $ads-breadcrumbs-link-color-hover);
    }
  }
}
